import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "./metaPixelAnalytics";

/**
 * SPA: fire PageView on client-side navigations (initial load is tracked in index.html).
 */
export default function MetaPixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackMetaPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
}
